module.exports = __webpack_public_path__ + "static/media/pt2030.6b77e214.webp";